/** @format */

import React from 'react';

import {ColumnType} from 'components/Table/core/types';

import YandexDirectLink from '../YandexDirectLink';
import {Campaign} from '../../types';

export const CAMPAIGNS_COLUMNS: ColumnType[] = [
  {
    id: 'id',
    title: 'ID',
    enableFilter: false,
    size: 150,
  },
  {
    id: 'name',
    title: 'Название',
    enableFilter: false,
    size: 300,
    cell: info => {
      const row = info.row.original as unknown as Campaign;
      const campaignName = info.getValue() as string;
      const {id: campaignId, accountName} = row;

      return (
        <YandexDirectLink
          campaignId={campaignId}
          campaignName={campaignName}
          accountName={accountName}
        />
      );
    },
  },
];

export const METRIC_GOALS_COLUMNS: ColumnType[] = [
  {
    id: 'metric',
    title: 'Метрика',
    enableFilter: false,
    children: [
      {
        id: 'metricId',
        title: 'ID',
        enableFilter: false,
        size: 100,
      },
      {
        id: 'metricName',
        title: 'Название',
        enableFilter: false,
        size: 200,
      },
    ],
  },
  {
    id: 'goal',
    title: 'Цель',
    enableFilter: false,
    children: [
      {
        id: 'goalId',
        title: 'ID',
        enableFilter: false,
        size: 100
      },
      {
        id: 'goalName',
        title: 'Название',
        enableFilter: false,
        size: 200,
      },
    ],
  },
];
